import { AihubPickerModule } from "@aihub/ui/picker";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { DeloitteAiCardsModule } from "@shared/cards/cards.module";
import { DeloitteAiIconModule } from "@shared/icon/src/icon.module";
import { FilterModule } from "../filter/filter.module";
import { BrainCatalogComponent, BrainCatalogHeaderDirective } from "./ui/catalog";
import { BrainCatalogFilterComponent, BrainCatalogHideIfFilteredDirective } from "./ui/filter";
import { BrainCatalogProductsComponent } from "./ui/product-group";



@NgModule({
    declarations: [
        BrainCatalogComponent,
        BrainCatalogProductsComponent,
        BrainCatalogFilterComponent,
        BrainCatalogHeaderDirective,
        BrainCatalogHideIfFilteredDirective
    ],
    imports: [
        AihubPickerModule,
        CommonModule,
        DeloitteAiCardsModule,
        DeloitteAiIconModule,
        RouterModule,
        FilterModule
    ],
    exports: [
        BrainCatalogComponent,
        BrainCatalogProductsComponent,
        BrainCatalogHeaderDirective,
        BrainCatalogHideIfFilteredDirective,
        FilterModule
    ],
    providers: [],
})
export class BrainCatalogModule {
}
